import React from "react";
import { Wrapper, HeroButton } from "./styles";

export default function WeResolve({ toggleQrModal }) {
  return (
    <Wrapper>
      <div className="content">
        <div className="text-content">
          <div className="title">
            O que <span>Resolvemos</span>?
          </div>
          <div className="description">
            Nosso foco está em criar soluções inovadoras de{" "}
            <span>autenticação baseada em "prova de vida"</span>, que utilizam
            inteligência artificial de ponta e análise biométrica para garantir
            que cada acesso seja seguro, simples e confiável.
          </div>
          <HeroButton onClick={toggleQrModal}>Comece seu projeto</HeroButton>
        </div>
        <img
          src="assets/dark/development-image2.png"
          alt="Imagem representando diferentes funções do celular"
        />
      </div>
    </Wrapper>
  );
}
